import script from "./ComercialChart1.vue?vue&type=script&setup=true&lang=js"
export * from "./ComercialChart1.vue?vue&type=script&setup=true&lang=js"

import "./ComercialChart1.vue?vue&type=style&index=0&id=23e2b6d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e2b6d0"]])

export default __exports__